<template>
    <form @submit.prevent="submit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Update Tag</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Name">
                    <b-input type="text" v-model="data.name"></b-input>
                </b-field>

                <b-field label="Type">
                    <b-input type="text" v-model="data.type"></b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary" :disabled="loading">Update</button>
            </footer>
        </div>
    </form>
</template>
<script>
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
    tagService: TagService,
    data: () => ({
        loading: false,
        data: {
            name: null,
            type: null
        }
    }),
    props:{
        tag: {
            required: true
        },
    },
    watch:{
        tag(){
            this.data.name = this.tag.name
            this.data.type = this.tag.type
        }
    },
    created(){
        this.data.name = this.tag.name
        this.data.type = this.tag.type
    },
    methods: {
        async submit() {
            try {
                let formData = new FormData();
                formData.append("name", this.data.name);
                formData.append("type", this.data.type);
                let tag = await this.$options.tagService
                    .update(this.tag.id, formData)
                    .then(response => JsonDenormalizer.denormalize(response));
                this.$emit("tagUpdated", tag);
                this.$parent.close();
            } catch (err) {}
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Tags/list/partials/updateTagModal.vue